<div class="content-wrapper">

  <section class="content-header">
      <h1>
          {{ editando ? 'Edição do' : 'Novo' }} Cronograma Financeiro
          <small>Preencha as informações necessárias</small>
      </h1>
      <ol class="breadcrumb">
          <li>
              <a routerLink="/home">
                  <i class="fa fa-home"></i> Home</a>
          </li>
          <li>
              <a routerLink="/cronograma-financeiro">Cronograma finaceiro</a>
          </li>
          <li class="active">Novo Cronograma</li>
      </ol>
  </section>

  <br>

  <div class="col-md-12">

      <div class="box box-primary">

          <div class="panel-body">

              <h3>Identificação do Cronograma</h3>
              <hr>

              <form #f="ngForm" autocomplete="off" (ngSubmit)="salvar(f)">

                  <div class="ui-g">

                      <!-- <div class="ui-g-12 ui-md-6 ui-fluid">
                          <label>Entidade Concedente:</label>
                          <p-select name="entidade" [options]="entidades" placeholder="Selecione" [filter]="true" [(ngModel)]="comissaoSelecao.entidadeConcedente.id"
                              required></p-select>
                      </div>

                      <div class="ui-g-12 ui-fluid">
                          <label>Nome:</label>
                          <input pInputText type="text" name="nome" [(ngModel)]="comissaoSelecao.nome" #nome="ngModel" required>
                      </div> -->

                  </div>


                  <div class="box-footer">
                      <button type="submit" class="btn btn-primary ">Salvar</button>
                      &nbsp;
                      <a (click)="novo(f)">Limpar formulário</a>
                  </div>


              </form>

          </div>

      </div>

  </div>

</div>